import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import SignatureCanvas from 'react-signature-canvas'
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../store/actions/index';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Footer from '../../src/containers/Footer/Footer'
import converter from 'number-to-chinese-words';
import PrimaryAppBarMobile from "../components/PrimaryAppBarMobile";
import withSizes from "react-sizes";
import arrowRight from '../../src/images/arrowRight.svg';
import leftIcon from '../images/left.png';

const styles = theme => ({
    container: {
        width: '95%'
    },
    root: {
      width: '95%',
      minHeight: '500px',
      //marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      margin: '0 Auto',
      //display: 'flex',
      //justifyContent: 'center',
    },
    table: {
      tableLayout: 'auto',
      minWidth: 300,
    },
    header:{
        backgroundColor: 'primary',
    },
    leftCell: {
        borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    },
    margin:{
      margin:'20px'
    },
    textField: {
      width: 200,
    },
  });


class ArbitrationAgreement extends Component{

    state = {
      firstPartyName: null,
      secondPartyName:null,
      firstPartyEmail:null,
      secondPartyEmail:null,
      firstPartyContact:null,
      secondPartyContact:null,
      date:'',
      date2:'',
      trimmedDataURL: null,
      trimmedDataURL2: null,
      description:'',
      agreementNo:'',

      firstname:false,
      secondname:false,
      firstemail:false,
      secondemail:false,
      firstsig:false,
      secondsig:false,

      windowHeight: undefined,
      windowWidth: undefined,
      language: localStorage.getItem('language')
    };

    sigPad = {}
    sigPad2 = {}

    clear = () => {
      this.sigPad.clear()
    }
  
    trim = () => {
      this.setState({ trimmedDataURL: this.sigPad.getTrimmedCanvas().toDataURL('image/png') })
    }

    clear2 = () => {
      this.sigPad2.clear()
    }
  
    trim2 = () => {
      this.setState({ trimmedDataURL2: this.sigPad2.getTrimmedCanvas().toDataURL('image/png') })
    }

    handleResize = () => {
      this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth
      })
    } 

    componentWillMount() {
      window.removeEventListener('resize', this.handleResize)
    }

    componentDidMount(){
        var today = new Date();
        const timestamp = Date.now();
        var tstamp = ''+timestamp;
        var t = tstamp.slice(9,tstamp.length);
        let ra = String(Math.floor(Math.random() * 100)).padStart(1, '0');
        var ft = t+''+ra
        this.setState({
          agreementNo: ft
        })

        this.handleResize();
        window.addEventListener('resize', this.handleResize)

        var month = 'January';
        var date = '1st'

        var month2 = 'January';
        var date2 = '1st'
        console.log(' ArbiAgree: lang: '+this.props.lang)
        if (this.props.lang == 'en'){

          if ( (today.getDate()) == '1' ){
            date = '1st';
          }
          else if ( (today.getDate()) == '2' ){
            date = '2nd';
          }
          else if ( (today.getDate()) == '3' ){
            date = '3rd';
          }
          else if ( (today.getDate()) == '4' ){
            date = '4th';
          }
          else if ( (today.getDate()) == '5' ){
            date = '5th';
          }
          else if ( (today.getDate()) == '6' ){
            date = '6th';
          }
          else if ( (today.getDate()) == '7' ){
            date = '7th';
          }
          else if ( (today.getDate()) == '8' ){
            date = '8th';
          }
          else if ( (today.getDate()) == '9' ){
            date = '9th';
          }
          else if ( (today.getDate()) == '10' ){
            date = '10th';
          }
          else if ( (today.getDate()) == '11' ){
            date = '11th';
          }
          else if ( (today.getDate()) == '12' ){
            date = '12th';
          }
          else if ( (today.getDate()) == '13' ){
            date = '13th';
          }
          else if ( (today.getDate()) == '14' ){
            date = '14th';
          }
          else if ( (today.getDate()) == '15' ){
            date = '15th';
          }
          else if ( (today.getDate()) == '16' ){
            date = '16th';
          }
          else if ( (today.getDate()) == '17' ){
            date = '17th';
          }
          else if ( (today.getDate()) == '18' ){
            date = '18th';
          }
          else if ( (today.getDate()) == '19' ){
            date = '19th';
          }
          else if ( (today.getDate()) == '20' ){
            date = '20th';
          }
          else if ( (today.getDate()) == '21' ){
            date = '21st';
          }
          else if ( (today.getDate()) == '22' ){
            date = '22nd';
          }
          else if ( (today.getDate()) == '23' ){
            date = '23rd';
          }
          else if ( (today.getDate()) == '24' ){
            date = '24th';
          }
          else if ( (today.getDate()) == '25' ){
            date = '25th';
          }
          else if ( (today.getDate()) == '26' ){
            date = '26th';
          }
          else if ( (today.getDate()) == '27' ){
            date = '27th';
          }
          else if ( (today.getDate()) == '28' ){
            date = '28th';
          }
          else if ( (today.getDate()) == '29' ){
            date = '29th';
          }
          else if ( (today.getDate()) == '30' ){
            date = '30th';
          }
          else if ( (today.getDate()) == '31' ){
            date = '31st';
          }

          if ( (today.getMonth()+1) == '1' ){
            month = 'January';
          }
          else if ( (today.getMonth()+1) == '2' ){
            month = 'February';
          }
          else if ( (today.getMonth()+1) == '3' ){
            month = 'March';
          }
          else if ( (today.getMonth()+1) == '4' ){
            month = 'April';
          }
          else if ( (today.getMonth()+1) == '5' ){
            month = 'May';
          }
          else if ( (today.getMonth()+1) == '6' ){
            month = 'June';
          }
          else if ( (today.getMonth()+1) == '7' ){
            month = 'July';
          }
          else if ( (today.getMonth()+1) == '8' ){
            month = 'August';
          }
          else if ( (today.getMonth()+1) == '9' ){
            month = 'September';
          }
          else if ( (today.getMonth()+1) == '10' ){
            month = 'October';
          }
          else if ( (today.getMonth()+1) == '11' ){
            month = 'November';
          }
          else if ( (today.getMonth()+1) == '12' ){
            month = 'December';
          }
        }
        else if (this.props.lang == 'cn'){

          if ( (today.getDate()) == '1' ){
            date = '一';
          }
          else if ( (today.getDate()) == '2' ){
            date = '二';
          }
          else if ( (today.getDate()) == '3' ){
            date = '三';
          }
          else if ( (today.getDate()) == '4' ){
            date = '四';
          }
          else if ( (today.getDate()) == '5' ){
            date = '五';
          }
          else if ( (today.getDate()) == '6' ){
            date = '六';
          }
          else if ( (today.getDate()) == '7' ){
            date = '七';
          }
          else if ( (today.getDate()) == '8' ){
            date = '八';
          }
          else if ( (today.getDate()) == '9' ){
            date = '九';
          }
          else if ( (today.getDate()) == '10' ){
            date = '十';
          }
          else if ( (today.getDate()) == '11' ){
            date = '十一';
          }
          else if ( (today.getDate()) == '12' ){
            date = '十二';
          }
          else if ( (today.getDate()) == '13' ){
            date = '十三';
          }
          else if ( (today.getDate()) == '14' ){
            date = '十四';
          }
          else if ( (today.getDate()) == '15' ){
            date = '十五';
          }
          else if ( (today.getDate()) == '16' ){
            date = '十六';
          }
          else if ( (today.getDate()) == '17' ){
            date = '十七';
          }
          else if ( (today.getDate()) == '18' ){
            date = '十八';
          }
          else if ( (today.getDate()) == '19' ){
            date = '十九';
          }
          else if ( (today.getDate()) == '20' ){
            date = '二十';
          }
          else if ( (today.getDate()) == '21' ){
            date = '二十一';
          }
          else if ( (today.getDate()) == '22' ){
            date = '二十二';
          }
          else if ( (today.getDate()) == '23' ){
            date = '二十三';
          }
          else if ( (today.getDate()) == '24' ){
            date = '二十四';
          }
          else if ( (today.getDate()) == '25' ){
            date = '二十五';
          }
          else if ( (today.getDate()) == '26' ){
            date = '二十六';
          }
          else if ( (today.getDate()) == '27' ){
            date = '二十七';
          }
          else if ( (today.getDate()) == '28' ){
            date = '二十八';
          }
          else if ( (today.getDate()) == '29' ){
            date = '二十九';
          }
          else if ( (today.getDate()) == '30' ){
            date = '三十';
          }
          else if ( (today.getDate()) == '31' ){
            date = '三十一';
          }

          if ( (today.getMonth()+1) == '1' ){
            month = '一月';
          }
          else if ( (today.getMonth()+1) == '2' ){
            month = '二月';
          }
          else if ( (today.getMonth()+1) == '3' ){
            month = '三月';
          }
          else if ( (today.getMonth()+1) == '4' ){
            month = '四月';
          }
          else if ( (today.getMonth()+1) == '5' ){
            month = '五月';
          }
          else if ( (today.getMonth()+1) == '6' ){
            month = '六月';
          }
          else if ( (today.getMonth()+1) == '7' ){
            month = '七月';
          }
          else if ( (today.getMonth()+1) == '8' ){
            month = '八月';
          }
          else if ( (today.getMonth()+1) == '9' ){
            month = '九月';
          }
          else if ( (today.getMonth()+1) == '10' ){
            month = '十月';
          }
          else if ( (today.getMonth()+1) == '11' ){
            month = '十一月';
          }
          else if ( (today.getMonth()+1) == '12' ){
            month = '十二月';
          }
        }

          if ( (today.getDate()) == '1' ){
            date2 = '1st';
          }
          else if ( (today.getDate()) == '2' ){
            date2 = '2nd';
          }
          else if ( (today.getDate()) == '3' ){
            date2 = '3rd';
          }
          else if ( (today.getDate()) == '4' ){
            date2 = '4th';
          }
          else if ( (today.getDate()) == '5' ){
            date2 = '5th';
          }
          else if ( (today.getDate()) == '6' ){
            date2 = '6th';
          }
          else if ( (today.getDate()) == '7' ){
            date2 = '7th';
          }
          else if ( (today.getDate()) == '8' ){
            date2 = '8th';
          }
          else if ( (today.getDate()) == '9' ){
            date2 = '9th';
          }
          else if ( (today.getDate()) == '10' ){
            date2 = '10th';
          }
          else if ( (today.getDate()) == '11' ){
            date2 = '11th';
          }
          else if ( (today.getDate()) == '12' ){
            date2 = '12th';
          }
          else if ( (today.getDate()) == '13' ){
            date2 = '13th';
          }
          else if ( (today.getDate()) == '14' ){
            date2 = '14th';
          }
          else if ( (today.getDate()) == '15' ){
            date2 = '15th';
          }
          else if ( (today.getDate()) == '16' ){
            date2 = '16th';
          }
          else if ( (today.getDate()) == '17' ){
            date2 = '17th';
          }
          else if ( (today.getDate()) == '18' ){
            date2 = '18th';
          }
          else if ( (today.getDate()) == '19' ){
            date2 = '19th';
          }
          else if ( (today.getDate()) == '20' ){
            date2 = '20th';
          }
          else if ( (today.getDate()) == '21' ){
            date2 = '21st';
          }
          else if ( (today.getDate()) == '22' ){
            date2 = '22nd';
          }
          else if ( (today.getDate()) == '23' ){
            date2 = '23rd';
          }
          else if ( (today.getDate()) == '24' ){
            date2 = '24th';
          }
          else if ( (today.getDate()) == '25' ){
            date2 = '25th';
          }
          else if ( (today.getDate()) == '26' ){
            date2 = '26th';
          }
          else if ( (today.getDate()) == '27' ){
            date2 = '27th';
          }
          else if ( (today.getDate()) == '28' ){
            date2 = '28th';
          }
          else if ( (today.getDate()) == '29' ){
            date2 = '29th';
          }
          else if ( (today.getDate()) == '30' ){
            date2 = '30th';
          }
          else if ( (today.getDate()) == '31' ){
            date2 = '31st';
          }

          if ( (today.getMonth()+1) == '1' ){
            month2 = 'January';
          }
          else if ( (today.getMonth()+1) == '2' ){
            month2 = 'February';
          }
          else if ( (today.getMonth()+1) == '3' ){
            month2 = 'March';
          }
          else if ( (today.getMonth()+1) == '4' ){
            month2 = 'April';
          }
          else if ( (today.getMonth()+1) == '5' ){
            month2 = 'May';
          }
          else if ( (today.getMonth()+1) == '6' ){
            month2 = 'June';
          }
          else if ( (today.getMonth()+1) == '7' ){
            month2 = 'July';
          }
          else if ( (today.getMonth()+1) == '8' ){
            month2 = 'August';
          }
          else if ( (today.getMonth()+1) == '9' ){
            month2 = 'September';
          }
          else if ( (today.getMonth()+1) == '10' ){
            month2 = 'October';
          }
          else if ( (today.getMonth()+1) == '11' ){
            month2 = 'November';
          }
          else if ( (today.getMonth()+1) == '12' ){
            month2 = 'December';
          }
        
          var y = ''+today.getFullYear()
          var yy = y.split('');
          var y1 = yy[0];
          var y2 = yy[1];
          var y3 = yy[2];
          var y4 = yy[3];
          var year1 = converter.toWords( parseInt(y1) );
          var year2 = converter.toWords( parseInt(y2) );
          var year3 = converter.toWords( parseInt(y3) );
          var year4 = converter.toWords( parseInt(y4) );

        // var d = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()
        // var d='';
        if (this.props.lang == 'en'){
          var d = date +' '+month +' '+ today.getFullYear()
          this.setState({ date : d });
        }
        else if (this.props.lang == 'cn'){
          var d = year1+year2+year3+year4+'年'+month+date +'日'
          this.setState({ date : d });
        }
        
        var d2 = date2 +' '+month2 +' '+ today.getFullYear()
        this.setState({ date2 : d2 });

    }

    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    
    async checker(){
      if (this.sigPad.isEmpty()){
        this.setState({
          firstsig:true
        })
      }
      if (this.sigPad2.isEmpty()){
        this.setState({
          secondsig:true
        })
      }
      if (this.state.firstPartyName == null){
        this.setState({
          firstname:true
        })
      }
      else{
        this.setState({
          firstname:false
        })
      }
      if (this.state.secondPartyName == null){
        this.setState({
          secondname:true
        })
      }
      else{
        this.setState({
          secondname:false
        })
      }
      if (this.state.firstPartyEmail == null){
        this.setState({
          firstemail:true
        })
      }
      else{
        var re = this.validateEmail(this.state.firstPartyEmail)
        if (re){
          this.setState({
            firstemail:false
          })
        }
        else{
          this.setState({
            firstemail:true
          })
        }
      }

      if (this.state.secondPartyEmail == null){
        this.setState({
          secondemail:true
        })
      }
      else{
        var re2 = this.validateEmail(this.state.secondPartyEmail)
        if (re2){
          this.setState({
            secondemail:false
          })
        }
        else{
          this.setState({
            secondemail:true
          })
        }
      }
    }

    submitHandler = async (event) => {
      event.preventDefault();
      console.log('The state is: '+JSON.stringify(this.state))

      await this.checker();
      var d1 = ''+(this.state.trimmedDataURL)
      var d1_ = d1.replace('data:image/png;base64,','');
      var d2 = ''+(this.state.trimmedDataURL2)
      var d2_ = d2.replace('data:image/png;base64,','');
      
      console.log('!this.sigPad.isEmpty(): '+(!this.sigPad.isEmpty()))
      console.log('!this.sigPad2.isEmpty(): '+(!this.sigPad2.isEmpty()))

      console.log('this.state.firstPartyName: '+this.state.firstPartyName )
      console.log('this.state.secondPartyName: '+this.state.secondPartyName )

      console.log('this.state.firstPartyEmail: '+this.state.firstPartyEmail )
      console.log('this.state.secondPartyEmail: '+this.state.secondPartyEmail )

      console.log('can send: '+(!this.sigPad.isEmpty() && !this.sigPad2.isEmpty() && this.state.firstname == false && this.state.secondname == false && this.state.firstemail == false && this.state.secondemail == false))
      if (!this.sigPad.isEmpty() && !this.sigPad2.isEmpty() && this.state.firstname == false && this.state.secondname == false && this.state.firstemail == false && this.state.secondemail == false){
        this.props.saveArbiAgreement(this.state.date2, this.state.firstPartyName, this.state.secondPartyName, this.state.firstPartyEmail,  this.state.secondPartyEmail,  this.state.description, d1_, d2_, this.state.agreementNo, this.state.secondPartyContact, this.state.firstPartyContact);
      }
    };

    handleChange = prop => event => {
      console.log('arbitration agreement: handleChange: prop: '+prop + ' event.target.value:'+ event.target.value)
      this.setState({ [prop]: event.target.value });

      this.setState({
        firstsig:false,
        secondsig:false,
        firstname:false,
        secondname:false,
        firstemail:false,
        secondemail:false
      })
    }

    handleClick() {
      this.props.history.push(`/`)
    }

    render(){
      const { classes } = this.props;
      return (
           <Grid
              container
              direction="row"
              justify="space-evenly"
              alignItems="flex-start"
              style={{padding: this.props.isDesktop?'10px':''}}
            >
              <PrimaryAppBarMobile
                lang={this.props.lang}
                isAuthenticated={this.props.isAuthenticated}
                logoSize={"20%"}
              />
               <div style={{ width:'100vw', float:'left' }}>
                  <Button onClick={(e)=>{this.handleClick()}} style={{textAlign:'left'}}><img style={{width:'15%'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                </div>
              <Grid
                container
                direction="row"
                justify="space-evenly"
                alignItems="flex-start"
                style={{paddingLeft: this.state.windowWidth <= 1200 || this.props.isMobile?'20px':'180px', paddingRight:this.state.windowWidth <= 1200 || this.props.isMobile?'20px':'180px'}}
                >
                 
               
                <Grid item style={{width:'-webkit-fill-available'}}>
                  <Typography style={{color:'#B71C1C', fontSize:'25px', fontWeight:'bold', textAlign:'center'}} width="100%" variant="h5" align='justify' gutterBottom FullWidth >
                      {this.context.t('Arbitration Agreement')}
                    </Typography>

                    <Typography width="100%" variant="h5" align='justify' gutterBottom FullWidth >
                      {this.context.t('(Parties to an existing dispute in which neither an arbitration clause nor a previous agreement with respect to arbitration exists, may sign the following agreement to refer such dispute to arbitration through our Online Arbitration Platform)')}
                    </Typography>
                    <br></br>
                    <Typography width="100%" variant="h5" align='justify' gutterBottom FullWidth >
                      {this.context.t('AgreementNo')}: {this.state.agreementNo}
                    </Typography>
                    <br></br>
                    <Typography width="100%" variant="h5" align='justify' gutterBottom FullWidth >
                      {this.context.t('Date')}: {this.state.date}
                    </Typography>
                    <br></br>
                    {this.props.lang == 'en' && <Typography width="100%" variant="h5" align='justify' gutterBottom FullWidth >
                      {this.context.t('arbitration_agreement1')}
                    </Typography>}
                    {this.props.lang == 'cn' && <Typography width="100%" variant="h5" align='justify' gutterBottom FullWidth >
                      {this.context.t('arbitration_agreement3')}
                    </Typography>}
                    <br></br>
                    <Typography style={{color:'#B71C1C', fontSize:'16px',textAlign:'left'}} width="100%" variant="h5" align='justify' gutterBottom FullWidth >
                      {this.context.t('arbitration_agreement2')}
                    </Typography>
                    <br></br>
                    {/* <Grid item>
                      <FormControl className={classes.margin} style={{textAlign:'center'}} FullWidth> */}
                            {/* <InputLabel style={{ fontSize: '14px'}} htmlFor="current-password" error={this.props.error}>{this.context.t('arbitration_agreement2')}</InputLabel> */}
                            <TextField
                              id="outlined-multiline-static"
                              placeholder={this.context.t('descriptionPlaceholder')}
                              multiline
                              rows={4}
                              inputProps={{ style: {fontSize: 14,  height:'100px'} }}
                              onChange={this.handleChange('description')}
                              style={{width: this.state.windowWidth <= 500 || this.props.isMobile?'100%':'100%', marginBottom:'30px'}}
                              variant="outlined"
                            />
                      {/* </FormControl>
                    </Grid> */}
                </Grid> 
                
                
              </Grid>

              <Grid container style={{backgroundColor:'#99192D'}} spacing={6} alignItems='center' direction='row' justify='space-evenly'>
                  <Grid item alignItems='center' direction='row' justify='center' >
                      <FormControl className={classes.margin} style={{color:'white'}}>

                        <Grid alignItems='center' direction='column' justify='center' style={{paddingLeft: this.props.isDesktop?'15px':''}} >
                          {this.context.t('Name of 1st Party')} 
                          <input
                            style={{border:'1px solid black', color:'black', 
                            width: this.state.language=='en'?(this.props.isDesktop?'228px':'204px'): (this.props.isDesktop?'228px':'230px'),
                            marginLeft: this.state.language=='en'?(this.props.isDesktop?'41px':'10px'): (this.props.isDesktop?'41px':'10px')
                            }}
                            id="firstPartyName"
                            value={this.state.firstPartyName}
                            error={this.props.error}
                            onChange={this.handleChange('firstPartyName')}
                          />
                        </Grid>
                        <br></br>
                        <Grid alignItems='center' direction='column' justify='center' style={{paddingLeft: this.props.isDesktop?'15px':''}} >
                          {this.context.t('Contact of 1st Party')}
                          <input
                            style={{border:'1px solid black', color:'black', 
                            width: this.state.language=='en'?(this.props.isDesktop?'212px':'175px'): (this.props.isDesktop?'212px':'215px'),
                            marginLeft: this.state.language=='en'?(this.props.isDesktop?'27px':'10px'): (this.props.isDesktop?'43px':'10px')
                            }}
                            id="firstPartyContact"
                            value={this.state.firstPartyContact}
                            error={this.props.error}
                            type="tel"
                            onChange={this.handleChange('firstPartyContact')}
                            
                          />
                        </Grid>
                        <br></br>
                        <Grid alignItems='center' direction='column' justify='center' style={{paddingLeft: this.props.isDesktop?'15px':''}} >
                          {this.context.t('E-mail of 1st Party')}
                          <input
                            style={{border:'1px solid black', color:'black', 
                            width: this.state.language=='en'?(this.props.isDesktop?'196px':'168px'): (this.props.isDesktop?'196px':'196px'),
                            marginLeft: this.state.language=='en'?(this.props.isDesktop?'69px':'43px'): (this.props.isDesktop?'44px':'15px')
                            }}
                            id="firstPartyEmail"
                            value={this.state.firstPartyEmail}
                            error={this.props.error}
                            type="email"
                            onChange={this.handleChange('firstPartyEmail')}
                          />
                        </Grid>
                        <br></br>
                        <FormControl className={classes.margin} style={{margin:'10px', padding:'10px'}}>
                          <Typography style={{color:'white'}}>
                            {this.context.t('Signature of 1st Party:')}
                          </Typography>
                          <br></br>
                          <SignatureCanvas onEnd={this.trim} ref={(ref) => { this.sigPad = ref }} penColor='black' backgroundColor='rgb(252,248,248)' canvasProps={{width: 320, height: 200, className: 'sigCanvas', margin:40}} />
                          <button
                              variant="contained"
                              type="submit"
                              color="primary"
                              disabled={this.props.isSuccess == true}
                              // className={classes.button}
                              style={{backgroundColor:'transparent', border:'none'}}
                              onClick={this.clear} 
                          >
                          {this.context.t('Clear')}
                          </button>
                        </FormControl>

                      </FormControl>
                  </Grid>
                  { !this.props.isDesktop && <div style={{height:'23px', width: '100vw',background:'white'}}></div>}
                  <Grid item alignItems='center' direction='row' justify='center' >
                    <FormControl className={classes.margin} style={{color:'white'}}>

                      <Grid alignItems='center' direction='column' justify='center' style={{paddingLeft: this.props.isDesktop?'15px':''}} >
                              {this.context.t('Name of 2nd Party')}
                              <input
                                style={{border:'1px solid black', color:'black', 
                                width: this.state.language=='en'?(this.props.isDesktop?'228px':'204px'): (this.props.isDesktop?'228px':'230px'),
                                marginLeft: this.state.language=='en'?(this.props.isDesktop?'41px':'10px'): (this.props.isDesktop?'41px':'10px')
                                }}
                                id="secondPartyName"
                                value={this.state.secondPartyName}
                                error={this.props.error}
                                onChange={this.handleChange('secondPartyName')}
                              />
                      </Grid>
                      <br></br>
                      <Grid alignItems='center' direction='column' justify='center' style={{paddingLeft: this.props.isDesktop?'15px':''}} >
                              {this.context.t('Contact of 2nd Party')}
                              <input
                                style={{border:'1px solid black', color:'black', 
                                width: this.state.language=='en'?(this.props.isDesktop?'212px':'175px'): (this.props.isDesktop?'212px':'215px'),
                                marginLeft: this.state.language=='en'?(this.props.isDesktop?'27px':'10px'): (this.props.isDesktop?'43px':'10px')
                                }}
                                id="secondPartyContact"
                                value={this.state.secondPartyContact}
                                error={this.props.error}
                                type="tel"
                                onChange={this.handleChange('secondPartyContact')}
                            />
                      </Grid>
                      <br></br>
                      <Grid alignItems='center' direction='column' justify='center' style={{paddingLeft: this.props.isDesktop?'15px':''}} >
                              {this.context.t('E-mail of 2nd Party')}
                              <input
                                style={{border:'1px solid black', color:'black', 
                                width: this.state.language=='en'?(this.props.isDesktop?'196px':'168px'): (this.props.isDesktop?'196px':'196px'),
                                marginLeft: this.state.language=='en'?(this.props.isDesktop?'69px':'43px'): (this.props.isDesktop?'44px':'15px')
                                }}
                                id="secondPartyEmail"
                                value={this.state.secondPartyEmail}
                                error={this.props.error}
                                type="email"
                                onChange={this.handleChange('secondPartyEmail')}
                            />
                      </Grid>
                      <br></br>
                      <FormControl className={classes.margin} style={{margin:'10px', padding:'10px'}} >
                            <Typography style={{color:'white'}}>
                              {this.context.t('Signature of 2nd Party:')}
                            </Typography>
                            <br></br>
                            <SignatureCanvas onEnd={this.trim2} ref={(ref) => { this.sigPad2 = ref }} penColor='black' backgroundColor='rgb(252,248,248)' canvasProps={{width: 320, height: 200, className: 'sigCanvas', margin:40}} />
                            <button
                                variant="contained"
                                type="submit"
                                color="primary"
                                disabled={this.props.isSuccess == true}
                                // className={classes.button}
                                style={{backgroundColor:'transparent', border:'none'}}
                                onClick={this.clear2} 
                            >
                            {this.context.t('Clear')}
                            </button>
                      </FormControl>  
                      
                    </FormControl>
                  </Grid>
              </Grid>

              <Grid container spacing={16}  alignItems='center' direction='row' justify='center'>

                <FormControl className={classes.margin}>
                    {/* <Button
                        variant="contained"
                        type="submit"
                        color="primary"
                        disabled={this.props.isSuccess == true}
                        className={classes.button}
                        style={{visibility:'hidden'}}
                        onClick={this.submitHandler} 
                    >
                    {this.context.t('Submit')}
                    </Button> */}
                    <img style={{width:'100px', height:'100px'}} onClick={this.submitHandler}  src={arrowRight}></img>
                </FormControl>
                </Grid>

                {this.state.firstemail && <Typography variant="h5" gutterBottom>
                  {this.context.t('1st Party email is required or incorrect')}
                  </Typography>}
                <br></br>
                {this.state.secondemail && <Typography variant="h5" gutterBottom>
                {this.context.t('2nd Party email is required or incorrect')}
                <br></br>
                </Typography>}
                {this.state.firstname && <Typography variant="h5" gutterBottom>
                {this.context.t('1st Party name is required')}
                <br></br>
                </Typography>}
                {this.state.secondname && <Typography variant="h5" gutterBottom>
                {this.context.t('2nd Party name is required')}
                <br></br>
                </Typography>}
                {this.state.firstsig && <Typography variant="h5" gutterBottom>
                {this.context.t('1st Party signature is required')}
                <br></br>
                </Typography>}
                {this.state.secondsig && <Typography variant="h5" gutterBottom>
                {this.context.t('2nd Party signature is required')}
                <br></br>
                </Typography>}
                {this.props.isSuccess && <Typography variant="h5" gutterBottom>
                {this.context.t('The agreement has been successfully saved. Thank you.')}
                </Typography>}

                {(this.props.isDesktop) && <Footer/>}
                {/* {(!this.props.isMobile) && <Footer/>} */}

            </Grid>
    );
    }

}

ArbitrationAgreement.contextTypes = {
  t: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    isSuccess: state.arbiAgreement.arbiAgreement,
    lang: state.i18nState.lang,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveArbiAgreement: (date,firstPartyName,secondPartyName,firstPartyEmail,secondPartyEmail, description, firstsig,secondsig, agreementNo, firstPartyContact,secondPartyContact) => dispatch(actions.saveArbiAgreement(date,firstPartyName,secondPartyName,firstPartyEmail,secondPartyEmail, description, firstsig,secondsig, agreementNo,  firstPartyContact,secondPartyContact)),
  }
}

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

// export default withStyles(styles)(ArbitrationAgreement);
// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ArbitrationAgreement)));
export default connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps) (withStyles(styles)((ArbitrationAgreement))));
